// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Af4G","content":"styles_content__1XbD4","row":"styles_row__2N7XS","footer":"styles_footer__3Y1Z6","phraseLength":"styles_phraseLength__1EKck"};